import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';
import '../Utility/Normalize.js';
import '../Utility/SvgWrapper.js';
import { UnstyledList } from '../Utility/UnstyledList.js';

const SelectCustomerMenu = ({ children, sx, "data-testid": dataTestId, }) => {
    return (jsx(Wrapper, { "data-testid": dataTestId, sx: sx, children: children }));
};
const Wrapper = styled(UnstyledList)({
    display: "flex",
    flexDirection: "column",
    height: "calc(100vh - 56px)",
    overflowY: "auto",
});

export { SelectCustomerMenu };
//# sourceMappingURL=SelectCustomerMenu.js.map
